import styled from 'styled-components'
import { themeGet } from 'styled-system'

export const CharacterCounterText = styled.span`
  margin-top: 0.125rem;
  text-align: right;
  font-size: 0.75rem;
  color: ${themeGet('colors.darkGray')};
  font-family: ${themeGet('font.molde.medium')};
`

export const ErrorAndCounterWrapper = styled.div`
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
`

export const Error = styled.span`
  color: ${themeGet('colors.errorRed')};
  text-align: right;
  font-size: 0.75rem;
  font-family: ${themeGet('font.molde.medium')};
`

export const Label = styled.label`
  font-size: 0.75rem;
  font-family: ${themeGet('font.molde.medium')};
  color: ${themeGet('colors.darkGray')};
`

export const TextArea = styled.textarea.attrs(props => ({
  borderColor: props.hasError
    ? themeGet('colors.errorRed', 'red')(props)
    : themeGet('colors.blueGrayMedium')(props),
}))`
  width: auto;
  min-height: 100px;
  padding: 0.625rem;
  resize: none;
  border: 2px solid ${({ borderColor }) => borderColor};
  border-radius: 0.625rem;

  &::placeholder {
    color: ${themeGet('colors.darkGray')};
  }
`

export const TextAreaWithCharacterCounterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
